export class CsTemplateHelper {
    /**
     * Applies a template to an element and replaces placeholders with attributes.
     * The template helper checks for if-attributes and removes the element if the attribute is not set.
     *
     * Example, if you only want to show a postTitle if it is set:
     * <span if="postTitle">{{postTitle}}</span>
     *
     * @param template
     * @param element
     * @param elementId
     */
    static applyTemplate(template: string, element: HTMLElement, elementId?: string): string {
        let result = this.processHtmlString(template);

        if (elementId) {
            result = result.replace(/{{elementid}}/g, elementId);
        }

        // Replace attribute placeholders
        const attributes = element.getAttributeNames();
        attributes.forEach(attributeName => {
            const attributeValue = element.getAttribute(attributeName);
            if (attributeValue !== null) {
                result = result.replace(new RegExp(`\{\{${attributeName}\}\}`, 'g'), attributeValue);
            }
        });

        const parser = new DOMParser();
        const doc = parser.parseFromString(result, 'text/html');
        doc.querySelectorAll('[if]').forEach(ifElement => {
            const attributeName = ifElement.getAttribute('if') ?? '';
            const attributeValue = element.getAttribute(attributeName);
            if (attributeValue === null || attributeValue === '') {
                ifElement.remove();
            }
        });

        return doc.body.innerHTML;
    }

    private static processHtmlString(htmlString: string) {
        return htmlString
            .replace(/\{\{([^\}]+)\}\}/g, (match, p1) => `\{\{${p1.toLowerCase()}\}\}`);
    }
}
